import { useEffect, useState, useCallback } from "react";
import useAuth from "./useAuth";
import useUserClient from "./useUserClient";
import useUserData from "./useUserData";

interface Usage {
  usage: number;
  quota: number | undefined;
}

export default function useUsage() {
  const { username, isLoggedIn } = useAuth();
  const { apiKey } = useUserData();
  const { userClient } = useUserClient();
  
  const [usage, setUsage] = useState<Usage | undefined>();

  const fetchUsage = useCallback(async () => {
    try {
      const { data, status, statusText } = await userClient.post('/usage', { username, apiKey });
      if (status !== 200) {
        throw new Error(`HTTP error: ${status} (${statusText})`);
      }
      setUsage(data as Usage);
    } catch (error) {
      console.error("Error #97", error);
    }
  }, [userClient, username, apiKey]);

  useEffect(() => {
    if (isLoggedIn && username) {
      fetchUsage();
    }
  }, [isLoggedIn, username, fetchUsage]);

  return { usage, refreshUsage: fetchUsage };
}
